<template>
	<div class="panel-group" :id="id">
		<slot />
	</div>
</template>
<script>
	import uid from 'js/uid';
	export default {
		name: 'accordion',
		data() {
			return {
				id: null,
			};
		},
		mounted() {
			this.id = uid();
		},
	};
</script>



// WEBPACK FOOTER //
// src/app-components/accordion/accordion.vue